import { render } from "./PageVideo.vue?vue&type=template&id=4bb66284&scoped=true"
import script from "./PageVideo.vue?vue&type=script&lang=js"
export * from "./PageVideo.vue?vue&type=script&lang=js"

import "./PageVideo.vue?vue&type=style&index=0&id=4bb66284&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb66284"]])

export default __exports__